import { create } from 'zustand'
import { createHomeStore } from './modules/home'
// import { mountStoreDevtool } from 'simple-zustand-devtools'


const useBoundStore = create(

  (...a) => ({
    ...createHomeStore(...a),
  }),
  {
    name: 'zustand_store', // 唯一key      
    // getStorage: () => sessionStorage, // (可选)默认使用'localStorage'
  }
)

// if (process.env.NODE_ENV === 'development') {
//   mountStoreDevtool('zustand_store', useBoundStore)
// }

export default useBoundStore